import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { localAssetUrl } from "../../utils/assets";

import "./../../assets/frontend/css/bootstrap.min.css";
import "./../../assets/frontend/css/owl.carousel.css";
import "./../../assets/frontend/css/owl.theme.css";
import "./../../assets/frontend/css/animated.css";
import "./../../assets/frontend/css/icon-ots.css";

const Header = () => {
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const isLoggedIn = isAuthenticated === true || !!user;
  const examinationTarget = isLoggedIn
    ? "/exams"
    : { pathname: "/login", state: { from: "/exams" } };

  const handleExamClick = () => {
    localStorage.removeItem("examId");
    localStorage.removeItem("examName");
    localStorage.removeItem("categoryId");
    localStorage.removeItem("courseId");
    localStorage.removeItem("subjects");
    localStorage.removeItem("assessmentId");
    localStorage.removeItem("assessmentName");
    localStorage.removeItem("assessmentSlug");
    localStorage.removeItem("checkedSubjects");
  };

  const [isActive, setActive] = useState(false);

  const handleToggleMenu = () => {
    setActive(!isActive);
  };

  /*useEffect(() => {
        setActive(false);
    }, []);*/

  return (
    <header className={isActive ? "menu-open" : null}>
      <nav className="custom-nav clearfix">
        <div className="logo">
          <Link to="/home">
            <img
              src={localAssetUrl("assets/img/logo.png")}
              alt="ONE TIME SUCCESS"
            />
          </Link>
        </div>
        <div className="main-nav pull-right">
          <ul onClick={(e) => setActive(false)}>
            <li>
              <a href={process.env.REACT_APP_LANDING_URL || "/"}>Welcome</a>
            </li>
            <li className="active">
              <Link to="/home">Home</Link>
            </li>
            <li>
              <Link to={examinationTarget} onClick={handleExamClick}>
                Examination
              </Link>
            </li>
            <li>
              <Link to="/pages/about-us">About Us</Link>
            </li>
            <li>
              <Link to="/news">News</Link>
            </li>
            <li>
              <Link to="/faqs">FAQs</Link>
            </li>
            <li>
              <Link to="/contact-us">Contact Us</Link>
            </li>

            {user ? (
              <li className="log-reg mar-left-nav">
                <Link to="/dashboard">Dashboard</Link>
              </li>
            ) : (
              <Fragment>
                <li className="log-reg mar-left-nav">
                  <Link to="/register">Register</Link>
                </li>
                <li className="log-reg" style={{ marginLeft: "5px" }}>
                  <Link to="/login">Login</Link>
                </li>
              </Fragment>
            )}
          </ul>
        </div>
        <div className="nav-togg" onClick={handleToggleMenu}>
          <span></span>
        </div>
      </nav>
    </header>
  );
};

export default Header;
